export default {
  'landing.memory': 'Давайте создадим воспоминания вместе',
  'landing.family': 'Испытайте лучшее путешествие вместе с семьей и друзьями',
  'landing.price':
    'Мы предоставляем самый простой процесс для поиска, покупки и возврата авиабилетов на все рейсы',
  'landing.point':
    'Купите авиабилеты по самой низкой цене, воспользовавшись специальной скидкой',
  'landing.point': 'Зарабатывайте баллы за каждое путешествие',
  'landing.buynow': 'Купите сейчас',
  'landing.scotland': 'Путешествие в Шотландию',
  'landing.ireland': 'Путешествие в Ирландию',
  'landing.egypt': 'Путешествие в Египет',
  'landing.greece': 'Путешествие в Грецию',
  'landing.person': 'Несколько человек уже ушли/уехали',
  'landing.categories': 'Это слово на японском означает "категория" на русском',
};
